// import accountingIcon from '../../common/images/accounting_launch_icon.svg';
import referencingIcon from '../../common/images/referencing_launch_icon.svg';
import taskIcon from '../../common/images/task_launch_icon.svg';
import timeIcon from '../../common/images/Group 20.png';
import peopleIcon from '../../common/images/Layer 2 (1).svg';
import payrollIcon from '../../common/images/Layer 2 (2).svg';
import assetIcon from '../../common/images/Layer 2 (3).svg';
import myteamIcon from '../../common/images/myteamIcon.svg';
import myEdgeIcon from '../../common/images/myedge_launch_icon.svg';
import recruitIcon from '../../common/images/recruit.svg';
import performanceIcon from '../../common/images/performance_icon.svg';
import chatIcon from '../../common/images/chat.svg';

export const NAV = [
  'access_payroll',
  'access_hr',
  'access_accounting',
  'access_assets',
  'access_vehicles'
];

const path = window.location.origin;
const logo = localStorage.getItem('logo');
const id = localStorage.getItem('business_domain');
const token = localStorage.getItem('access_token');

export const actions = [
  {
    title: 'People',
    description: 'Manage your people to drive an inclusive work culture',
    link: '/hr?type=all-employees&tab=all-employee-home',
    userModule: 'access_hr',
    icon: peopleIcon
  },
  {
    title: 'Payroll',
    description:
      'Compensation made easy. Pay your employees seamlessly and on-time',
    link: '/payroll?tab=home',
    access_payroll: '/payroll?tab=home',
    userModule: 'access_payroll',
    icon: payrollIcon
  },
  {
    title: 'Attendance',
    description: 'Seamlessly track employees daily attendances.',
    link: '/time-and-attendance?tab=daily-attendance',
    // beta: true,
    userModule: 'access_attendance',
    icon: timeIcon
  },
  {
    title: 'Recruit',
    link: '/recruit?screen=home',
    icon: recruitIcon,
    description:
      'Be great at hiring the best talent, and give your hires the best recruitment experience',
    beta: false,
    userModule: 'access_recruits_collaboration'
  },
  {
    title: 'Recruit',
    link: '/recruit?screen=home',
    icon: recruitIcon,
    description:
      'Be great at hiring the best talent, and give your hires the best recruitment experience',
    beta: false,
    userModule: 'access_recruits'
  },
  {
    title: 'Rota & Shifts',
    description:
      'Manage your company vehicles better so they can perform optimally',
    link: '/shift-rota',
    userModule: 'access_shift',
    icon: timeIcon,
    beta: false
  },
  {
    title: 'Assets & Vehicles',
    description:
      'Keep an assets register that helps you manage all your company assets easily',
    link: '/assets?tab=home',
    userModule: 'access_assets',
    icon: assetIcon
  },
  {
    title: 'Performance',
    description:
      'Send business documents on-time without typing them from scratch',
    link: '/performance',
    coming_soon: false,
    beta: false,
    icon: performanceIcon,
    userModule: 'access_performance'
  },
  {
    title: 'Referencing',
    description:
      'Send business documents on-time without typing them from scratch',
    link: '/reference',
    coming_soon: false,
    beta: false,
    icon: referencingIcon,
    userModule: 'access_reference'
  },
  // {
  //   title: 'Accounting',
  //   icon: accountingIcon,
  //   description:
  //     'Organize your accounting books all year round, create and send professional invoices',
  //   // link: '/accounts/overview',
  //   coming_soon: true,
  //   userModule: 'access_accounting'
  // },
  {
    beta: false,
    title: 'Task',
    userModule: 'access_task',
    icon: taskIcon,
    // coming_soon: true,
    external_link: true,
    description:
      'Organize your accounting books all year round, create and send professional invoices',
    link: `${
      path.includes('localhost')
        ? `http://localhost:3456?business=${id}&app=tasks&logo=${logo}&token=${token}`
        : path.includes('dev-app.coolowo.com')
        ? `https://mydev-app.coolowo.com?business=${id}&app=tasks&logo=${logo}&token=${token}`
        : `https://my.bizedgeapp.com?business=${id}&app=tasks&logo=${logo}&token=${token}`
    }`,
    modal: {
      title:
        'Task is for Employees. The logged in user is not linked to an employee record.',
      content: [
        {
          content_title:
            'You need an invitation to access the MyEdge Self-Service App.',
          body: "This invitation usually comes from your HR team or administrator. If you haven't received one yet, simply let them know! If you an Admin, open the employee profile and click invite to MyEdge."
        },
        {
          content_title: 'Accept Your MyEdge Invitation',
          body: "Once you receive the invitation, don't forget to accept it! This activates your MyEdge account and grants you access to all its features including Tasks"
        }
      ]
    }
  },
  {
    beta: false,
    title: 'Chat',
    userModule: 'access_chat',
    icon: chatIcon,
    // coming_soon: true,
    external_link: true,
    description:
      'Organize your accounting books all year round, create and send professional invoices',
    link: `${
      path.includes('localhost')
        ? `http://localhost:3456?app=home&open=chat&logo=${logo}&business=${id}&token=${token}`
        : path.includes('dev-app.coolowo.com')
        ? `https://mydev-app.coolowo.com?app=home&open=chat&logo=${logo}&business=${id}&token=${token}`
        : `https://my.bizedgeapp.com?app=home&open=chat&logo=${logo}&business=${id}&token=${token}`
    }`,
    modal: {
      title:
        'Chat is for Employees. The logged in user is not linked to an employee record.',
      content: [
        {
          content_title:
            'You need an invitation to access the MyEdge Self-Service App.',
          body: "This invitation usually comes from your HR team or administrator. If you haven't received one yet, simply let them know! If you an Admin, open the employee profile and click invite to MyEdge."
        },
        {
          content_title: 'Accept Your MyEdge Invitation',
          body: "Once you receive the invitation, don't forget to accept it! This activates your MyEdge account and grants you access to all its features including Tasks"
        }
      ]
    }
  },
  // {
  //   title: 'Vehicles',
  //   description:
  //     'Manage your company vehicles better so they can perform optimally',
  //   link: '/fleet?tab=home',
  //   userModule: 'access_vehicles',
  //   icon: vehicleIcon,
  //   disabled: true,
  //   tool: {
  //     title: `Vehicles has a new home`,
  //     desc: `We've moved vehicles to the assets app.`,
  //     actionText: 'View Vehicles'
  //   }
  // },
  {
    title: 'My Team',
    description:
      'Manage your company vehicles better so they can perform optimally',
    link: '/myteam?type=all-employees&tab=all-employee-home',
    userModule: 'access_myteam',
    icon: myteamIcon
  },
  {
    title: 'MyEdge',
    userModule: 'access_myedge',
    description:
      'Manage your company vehicles better so they can perform optimally',
    link: `${
      path.includes('localhost')
        ? `http://localhost:3456?business=${id}&app=home&logo=${logo}&token=${token}`
        : path.includes('dev-app.coolowo.com')
        ? `https://mydev-app.coolowo.com?business=${id}&app=home&logo=${logo}&token=${token}`
        : `https://my.bizedgeapp.com?business=${id}&app=home&logo=${logo}&token=${token}`
    }`,
    icon: myEdgeIcon,
    modal: {
      title:
        'MyEdge is for Employees. The logged in user is not linked to an employee record.',
      content: [
        {
          content_title:
            'You need an invitation to access the MyEdge Self-Service App.',
          body: "This invitation usually comes from your HR team or administrator. If you haven't received one yet, simply let them know! If you an Admin, open the employee profile and click invite to MyEdge."
        },
        {
          content_title: 'Accept Your MyEdge Invitation',
          body: "Once you receive the invitation, don't forget to accept it! This activates your MyEdge account and grants you access to all its features."
        }
      ]
    },
    external_link: true
  }
];
